import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PartnerAppReleases = lazy(() => import('./PartnerAppReleases'));
const AppReleasesListView = lazy(() => import('./views/AppReleasesListView'));
const AppReleaseDetailView = lazy(() => import('./views/AppReleaseDetailView'));
const UploadReleaseForm = lazy(() => import('./views/UploadReleaseForm'));
const ExternalReleaseForm = lazy(() => import('./views/ExternalReleaseForm'));

const PartnerAppReleasesRoute: FuseRouteItemType = {
	path: '/partner-app/releases',
	element: <PartnerAppReleases />,
	auth: ['Admin'], // Only Admin role can manage releases
	children: [
		{ index: true, element: <AppReleasesListView /> },
		{ path: 'upload', element: <UploadReleaseForm /> },
		{ path: 'external', element: <ExternalReleaseForm /> },
		{ path: ':id', element: <AppReleaseDetailView /> },
		{ path: ':id/edit', element: <AppReleaseDetailView /> } // Edit uses detail view for now
	]
};

export default PartnerAppReleasesRoute;
